import { useGetUsersQuery } from "./useGetUsersQuery";

export const useGetUserById = (id?: string) => {
  const { data } = useGetUsersQuery();

  return id ? data?.resources.find(user => user.userId === id) : undefined;
};
